import { DialogCloseIcon } from "@/components/shared/dialog-close";
import { Dialog, DialogContent } from "@/components/ui";
import { useAuthState } from "@/store/auth";

import { SignUpContent } from "../signup-content";

export function SignUpModal() {
  const {
    data: { signUpModalOpen },
    showModal,
  } = useAuthState();
  const onClose = () => {
    showModal();
  };
  return (
    <Dialog open={signUpModalOpen}>
      <DialogContent className="w-[343px]">
        <DialogCloseIcon onClose={onClose} />
        <SignUpContent />
      </DialogContent>
    </Dialog>
  );
}
